import { useRef, useState } from 'react';
import { useSendContactUsMessageMutation } from '../../Api/contactUs';
import { formatPhoneNumber } from '../../Helpers/phone-formatter';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import Input from '../../Style-guide/Input';
import Textarea from '../../Style-guide/Textarea';
import Title from '../../Style-guide/Title';
import ContactUsWrapper from './style/contactUsWrapper';
import { validateForm } from './validator';

const fields = {
  contactName: '',
  contactEmail: '',
  contactPhone: '',
  contactPurpose: '',
  contactMessage: '',
  contactFile: null,
};

const ContactUs = () => {
  const [contactForm, setContactForm] = useState({ ...fields });
  const [errors, setErrors] = useState({ ...fields });
  const fileInputRef = useRef(null);

  const tr = useTranslate();
  const { mutate: sendContactUsMessage } = useSendContactUsMessageMutation();

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setContactForm((prev) => ({
      ...prev,
      [name]: files?.[0] || (name === 'contactPhone' ? formatPhoneNumber(value) : value),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm(contactForm, tr);
    setErrors(validationErrors);
    const isFormValid = Object.values(validationErrors).every((msg) => msg === '');

    if (isFormValid) {
      const formData = new FormData();

      Object.entries(contactForm).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      sendContactUsMessage(
        {
          data: formData,
        },
        {
          onSuccess: () => {
            setContactForm({ ...fields });
            setErrors({ ...fields });

            if (fileInputRef.current) {
              fileInputRef.current.value = null;
            }
          },
        }
      );
    }
  };

  return (
    <ContactUsWrapper className='contact-us'>
      <Title size='LG' className='contact-us-title'>
        {tr('contact_us')}
      </Title>

      <form className='contact-us-form'>
        <div className='form-column message-content'>
          <Textarea
            className='contact-message-input'
            name='contactMessage'
            label={tr('message')}
            value={contactForm.contactMessage}
            error={errors.contactMessage}
            onChange={handleChange}
            maxLength={2000}
          />
          <input
            className='attachment-input'
            type='file'
            name='contactFile'
            onChange={handleChange}
            ref={fileInputRef}
            accept='.pdf,.doc,.docx,.jpg,.jpeg,.png'
          />
        </div>

        <div className='form-column contacts-column'>
          <Input
            className='contact-input'
            type='text'
            name='contactName'
            label={tr('full_name')}
            value={contactForm.contactName}
            error={errors.contactName}
            onChange={handleChange}
            autoComplete='off'
          />
          <Input
            className='contact-input'
            type='email'
            name='contactEmail'
            label={tr('email_address')}
            value={contactForm.contactEmail}
            error={errors.contactEmail}
            onChange={handleChange}
            autoComplete='off'
          />
          <Input
            className='contact-input'
            type='tel'
            name='contactPhone'
            label={tr('phone_number')}
            value={contactForm.contactPhone}
            error={errors.contactPhone}
            onChange={handleChange}
            autoComplete='off'
          />
          <Input
            className='contact-input'
            type='text'
            name='contactPurpose'
            label={tr('purpose')}
            value={contactForm.contactPurpose}
            error={errors.contactPurpose}
            onChange={handleChange}
            autoComplete='off'
          />
        </div>
      </form>
      <div className='contact-submit-button-wrapper'>
        <Button type='submit' className='contact-submit-button' onClick={handleSubmit}>
          {tr('submit')}
        </Button>
      </div>
    </ContactUsWrapper>
  );
};

export default ContactUs;
